import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DgDialogComponent } from './dg-dialog.component';
import { DgDialogConfig, DgDialogAction } from './dg-dialog.model';

@Injectable({
  providedIn: 'root',
})
export class DgDialogService {
  constructor(private dialog: MatDialog) {}

  open(config: DgDialogConfig): MatDialogRef<DgDialogComponent> {
    return this.dialog.open(DgDialogComponent, config);
  }

  alert(
    message: string,
    actions: DgDialogAction[] = [{ isPrimary: true, label: 'Ok', value: true }]
  ): MatDialogRef<DgDialogComponent> {
    return this.open({
      data: {
        title: 'Alert',
        titleIcon: 'warning',
        subtitle: message,
        actions,
      },
    });
  }

  info(
    message: string,
    actions: DgDialogAction[] = [
      { isPrimary: true, label: 'Dismiss', value: true },
    ]
  ): MatDialogRef<DgDialogComponent> {
    return this.open({
      data: {
        title: 'Info',
        titleIcon: 'info',
        subtitle: message,
        actions,
      },
    });
  }

  confirmation(
    message: string,
    positiveActionLabel: string = 'Yes',
    negativeActionLabel: string = 'No'
  ): MatDialogRef<DgDialogComponent> {
    return this.open({
      data: {
        title: message,
        actions: [
          {
            isPrimary: false,
            label: negativeActionLabel,
            value: false,
          },
          {
            isPrimary: true,
            label: positiveActionLabel,
            value: true,
          },
        ],
      },
    });
  }
}
